<template>
  <div class="category-item-wrapper flex" ref="root">
    <LoadingWidget v-show="loading" type="bar" ref="loading"></LoadingWidget>

    <div class="category-item-cont flex gap-12" v-show="!loading">
      <div class="category-details" ref="detailsCont">
        <div class="btn-cont flex">
          <ButtonVue
            label="<i class='material-symbols-outlined'>arrow_back</i> Back"
            type="invisible"
            @btn-click="$router.go(-1)">
          </ButtonVue>

          <ButtonVue
              ref="cancelBtn"
              class="child-right"
              v-show="editing"
              label="<i class='material-symbols-outlined'>cancel</i> Cancel"
              type="invisible danger"
              @btn-click="onCancel">
          </ButtonVue>
          <ButtonVue
              ref="saveBtn"
              class="save-btn"
              v-show="editing"
              label="<i class='material-symbols-outlined'>save</i> Save"
              type="invisible"
              @btn-click="onSave">
          </ButtonVue>
          <ButtonVue
              ref="editBtn"
              class="child-right"
              v-show="!editing"
              label="<i class='material-symbols-outlined'>edit</i> Edit"
              type="invisible"
              @btn-click="onEdit">
          </ButtonVue>
        </div>

        <div class="category flex gap-12">
          <div class="flex-1">
            <div class="field name primary-text large-text flex align-center">
              <span v-show="!editing" class="field-value">{{ store?.name }}</span>
              <TextInputVue
                v-model="update.name"
                name="categoryName"
                v-show="editing" />
            </div>

            <div class="field priority primary-text flex align-center">
              <span class="field-label">Priority: </span>
              <span v-show="!editing" class="field-value">{{ store?.priority }}</span>
              <NumberInputVue
                v-model="update.priority"
                name="categoryPriority"
                v-show="editing" />
            </div>
          </div>
          
          <div class="flex-1">
            <div class="field group primary-text flex align-center">
              <span class="field-label">Group: </span>
              <span v-show="!editing" class="field-value">{{ store?.group }}</span>
              <SelectInputVue
                v-model="update.group"
                name="categoryGroup"
                :options="categoryGroups"
                v-show="editing" />
            </div>
            <div class="field color primary-text flex align-center">
              <span class="field-label">Color: </span>
              <span v-show="!editing" class="field-value">{{ store?.color }}</span>
              <ColorInputVue
                v-model="update.color"
                name="categoryColor"
                v-show="editing" />
            </div>
          </div>
        </div>

        <div class="recent-purchases flex flex-column">
          <div class="label">
            Recent {{ category?.name }} Purchases
          </div>
  
          <div class="list-wrapper">
            <ListRow
              v-for="purchase in purchaseRows"
              :key="purchase.id"
              :model="purchase" />
          </div>
        </div>
      </div>

      <div class="history-chart-wrapper">
        <div class="chart-cont" ref="chartCont"></div>
      </div>

      <div class="error-cont hide" ref="errorCont">
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import ButtonVue from '@Common/components/ButtonCompVue'
import ColorInputVue from '@Common/components/ColorInputVue'
import NumberInputVue from '@Common/components/NumberInputVue'
import TextInputVue from '@Common/components/TextInputVue'
import SelectInputVue from '@Common/components/SelectInputVue'
import LoadingWidget from '@Common/elements/LoadingWidget'

import { groupedBarChart } from '@/charts/BarChart'
import ListRow from '@/components/lists/ListRow'
import { createPurchaseRows } from '@/libs/purchases'
import { axGet } from '@/utils/fetch_helpers'
import { createCategoryStore } from '@/stores/CategoryStore'

const CATEGORY_URL = `${process.env.VUE_APP_PIPES}/finances/categories`

export default {
  name: 'CategoryItem',

  setup() {
    const route = useRoute()

    const useCategoryStore = createCategoryStore(route.params.id)
    const store = useCategoryStore()
    return {
      store,
      route
    }
  },

  props: [],

  data () {
    return {
      id: this.$route.params.id,
      category: {
        name: '',
        recent: [{}], //TODO format date
        history: [],
        priority: 0,
      },
      history: [],
      loading: true,
      editing: false,
      categoryGroups: [],
      update: {
        name: '',
        priority: 0,
        group: 'OTHER',
        color: '#000000',
      },
    }
  },

  computed: {
    purchaseRows() {
      return createPurchaseRows(this.store.recent)
    },
  },

  methods: {
    showDetails() {
      this.update.name = this.store.name
      this.update.color = this.store.color
      this.update.priority = this.store.priority
      this.update.group = this.store.group
      this.loading = false
      this.history = this.$_.map(this.store.history, year => this.$_.map(year, month => month)).flat()
      this.createChart()
    },

    createChart() {
      const chart = groupedBarChart({
        data: this.history,
        cont: '.chart-cont',
        groupByKey: 'month',
        groupedKey: 'year',
        valueKey: 'total',
        width: this.$refs.root.clientWidth,
        height: 1000,
        font: 24,
      })

      this.$refs.chartCont.append(chart)
    },

    showError(err) {
      this.$refs.errorCont.innerText = err
      this.loading = false
    },

    onEdit() {
      this.editing = true
    },

    onSave() {
      this.$refs.saveBtn.toggleSpinner(true)
      this.store.update(this.update).then(
        () => {
          this.editing = false
        },
        () => {
          this.$refs.saveBtn.toggleSpinner(false)
        }
      )
    },
    
    onCancel() {
      this.editing = false
    },
  },

  created() {
    this.store.fetch(this.id).then(
    // axGet(`${CATEGORY_URL}/${this.id}`).then(
      () => {
        this.showDetails()
      },
      err => {
        this.showError(err)
      }
    )

    axGet(`${CATEGORY_URL}/groups`).then(
      r => this.categoryGroups = r,
      e => console.error(e)
    )
  },

  components: {
    ButtonVue,
    ColorInputVue,
    ListRow,
    LoadingWidget,
    NumberInputVue,
    SelectInputVue,
    TextInputVue,
  },
}
</script>

<style lang="scss" scoped>
.category-item-wrapper {
  margin: $margin 0;

  .category-details {
    flex: 1;
    margin: $margin 0;

    .btn-cont {
      .save-btn {
        margin-left: $marginSmall;
      }
    }

    .category {

      .field {
        margin-bottom: $marginSmall;
        height: 32px;

        .field-label {
          margin-right: $marginSmall;
        }

        .field-value {
        }
      }
    }

    .recent-purchases {
      margin: $margin 0;

      .date {
        margin-right: $margin;
      }

      .amount {
        margin-left: auto;
      }
    }
  }

  .history-chart-wrapper {
    flex: 1;
  }
}

@media screen and (max-width: $header-break) {
  .category-item-cont {
    max-width: 100%;
    flex-direction: column;
  }
}
</style>
